__turbopack_context__.v({
  "countryField": "BoutiquesListingInfo-module-scss-module__uvPMrG__countryField",
  "countryLabel": "BoutiquesListingInfo-module-scss-module__uvPMrG__countryLabel",
  "countrySelect": "BoutiquesListingInfo-module-scss-module__uvPMrG__countrySelect",
  "description": "BoutiquesListingInfo-module-scss-module__uvPMrG__description",
  "heading": "BoutiquesListingInfo-module-scss-module__uvPMrG__heading",
  "section": "BoutiquesListingInfo-module-scss-module__uvPMrG__section",
  "visuallyHidden": "BoutiquesListingInfo-module-scss-module__uvPMrG__visuallyHidden",
});
